import Sidebar from "../components/Sidebar.js";
import Header from "../components/Header.js";
import Table from "../components/Table.js";

function AppStatus({ status }) {
  let primaryColour = "";
  let secondaryColour = "";

  switch (status) {
    case "approved":
      primaryColour = "#198754";
      secondaryColour = "#caf9ca";
      break;

    case "pending":
      primaryColour = "#ffb020";
      secondaryColour = "#ffefc5";
      break;

    case "rejected":
      primaryColour = "#f33838";
      secondaryColour = "#ffd5d5";
      break;

    default:
      break;
  }
  return (
    <div className="App flex flex-row">
      <Sidebar />
      <div className="container py-8 px-[5rem] bg-[#fbfbfb]">
        <Header
          title={status + " Forms"}
          date="Sunday, 22 Dec 2024"
          buttons={true}
          colour={primaryColour}
          status={status}
        />
        <Table filterStat={status} colour={secondaryColour} />
      </div>
    </div>
  );
}
export default AppStatus;
